import { Helper } from "./helper.js";

export class IndividualDataHelper {
    public static create = () => {
        return function () {
            const tools = {
                getCorrespondingDirective: function (individualItem, isSingle, translations, injectEntityInModel) {
                    const result: any = {
                        model: (injectEntityInModel ? "entity." : "") +  /*"entity." + (isSingle === true ? "IndividualFields." : "") + */individualItem.Name,
                        visible: true,
                        required: individualItem.IsRequired,
                        readOnly: individualItem.IsReadOnly ?? false,
                        name: individualItem.DisplayName,
                        type: null
                    };
                    const dataSource: any = {};
                    let panelbar = null;

                    switch (individualItem.ComponentType) {
                        case -1:
                        case 2:
                        case 0:
                        case 1:
                        case 3:
                            switch (individualItem.Type) {
                                case 1:
                                case 2:
                                    result.type = "is-numeric-text-box";
                                    result.spinners = true;
                                    result.decimals = 50;
                                    result.format = "#.#################################################";
                                    break;
                                case 3:
                                    result.type = "is-numeric-text-box";
                                    result.spinners = true;
                                    result.decimals = 0;
                                    result.format = "#";
                                    break;
                                case 4:
                                    result.type = "checkbox";
                                    result.labelAndControlCombined = true;
                                    break;
                                case 5:
                                    if (individualItem.Display === 1) {
                                        result.type = "kendo-date-time-picker";
                                    } else {
                                        result.type = "kendo-date-picker";
                                    }
                                    break;
                                case 6:
                                case 7:
                                    result.type = individualItem.Value.RestrictValueToChoices === true || individualItem.ComponentType === 3 ? "kendo-drop-down-list" : "kendo-combo-box";
                                    result.optionLabel = translations["Standard.BitteWählen"];
                                    result.dataTextField = "text";
                                    result.dataValueField = "value";
                                    result.dataSource = /*"dataSources." + */individualItem.Name + "_ds";
                                    dataSource.name = individualItem.Name + "_ds";
                                    dataSource.data = this.createDataSource(individualItem.Value.Choices);
                                    break;
                                case 8:
                                    result.type = "textbox";
                                    result.multiLine = true;
                                    break;
                                case 0:
                                default:
                                    result.type = "textbox";
                                    result.maxLength = individualItem.Width;
                                    break;
                            }
                            break;
                        case 100:
                            result.type = "is-search-field";
                            result.listWidth = 650;
                            result.autocompleteEnabled = true;
                            result.autocompleteTemplate = "<table cellspacing='0' style='table-layout:fixed; width:650px'><colgroup><col style='width: 100px' /><col style='width: 250px' /><col style='width: 300px' /></colgroup><tr style='background-color:# if(data.Status == 1) { #\\#cccccc# } else { #inherit# } #'><td style='vertical-align:top; word-wrap: break-word;'>${data.AdrNr}</td><td style='vertical-align:top'>${data.AdrName}</td><td style='vertical-align:top'>${data.Plz}  ${data.Ort}</td></tr></table>";
                            result.autocompleteUrl = "AddressLookup/Find";
                            result.autocompleteDataTextField = "AdrNr";
                            result.autocompleteAdditionalFilterParameterName = "";
                            result.autocompleteAdditionalFilterParameter = "";
                            result.searchButtonEnabled = true;
                            result.searchWindowTitle = translations["Adresse.AdresseSuchen"];
                            result.searchWindowUrl = "DynamicSearch/Window/Address";

                            panelbar = {
                                visible: true,
                                type: "is-panelbar-details",
                                model: result.model,
                                url: "AddressLookup/AddressHeader",
                                template: "AddressDetails"
                            };
                            break;
                        case 110:
                            result.type = "is-search-field";
                            result.listWidth = 650;
                            result.autocompleteEnabled = true;
                            result.autocompleteTemplate = "<table cellspacing='0' style='table-layout:fixed; width:650px'><colgroup><col style='width: 100px' /><col style='width: 250px' /><col style='width: 300px' /></colgroup><tr style='background-color:# if(data.Status == 1) { #\\#cccccc# } else { #inherit# } #'><td style='vertical-align:top; word-wrap: break-word'>${data.MaschNr}</td># if(data.MaschBezeichnung != null) { #<td style='vertical-align:top'>${data.MaschBezeichnung}</td>#}else{#<td style='vertical-align:top'></td>#}#<td style='vertical-align:top'>${data.AdrName}</td></tr></table>";
                            result.autocompleteUrl = "MachineLookup/Find";
                            result.autocompleteDataTextField = "MaschNr";
                            result.autocompleteAdditionalFilterParameterName = "";
                            result.autocompleteAdditionalFilterParameter = "";
                            result.searchButtonEnabled = true;
                            result.searchWindowTitle = translations["Maschine.Maschinensuche"];
                            result.searchWindowUrl = "DynamicSearch/Window/Machine";

                            panelbar = {
                                visible: true,
                                type: "is-panelbar-details",
                                model: result.model,
                                url: "MachineLookup/MachineHeader",
                                template: "MachineDetails"
                            };
                            break;
                        case 120:
                            result.type = "is-search-field";
                            result.listWidth = 650;
                            result.autocompleteEnabled = false;
                            result.autocompleteTemplate = "";
                            result.autocompleteUrl = "";
                            result.autocompleteDataTextField = "";
                            result.autocompleteAdditionalFilterParameterName = "";
                            result.autocompleteAdditionalFilterParameter = "";
                            result.searchButtonEnabled = true;
                            result.searchWindowTitle = translations["Projekt.Projektsuche"];
                            result.searchWindowUrl = "DynamicSearch/Window/Project";

                            panelbar = {
                                visible: true,
                                type: "is-panelbar-details",
                                model: result.model,
                                url: "ProjectLookup/ProjectHeader",
                                template: "ProjectDetails"
                            };
                            break;
                        case 130:
                            result.type = "is-search-field";
                            result.listWidth = 650;
                            result.autocompleteEnabled = true;
                            result.autocompleteTemplate = "<table cellspacing='0' style='table-layout:fixed; width:250px'><colgroup><col style='width: 80px' /><col style='width: 100px' /><col style='width: 100px' /></colgroup><tr style='background-color:# if(data.StatusAsInt == 1) { #\\#cccccc# } else { #inherit# } #'><td style='vertical-align:top; word-wrap: break-word;'>${data.Ressnr}</td><td style='vertical-align:top'>${data.Name}</td><td style='vertical-align:top'>${data.Vorname}</td></tr></table>";
                            result.autocompleteUrl = "ResourceLookup/FindWithId";
                            result.autocompleteDataTextField = "Ressnr";
                            result.autocompleteAdditionalFilterParameterName = "";
                            result.autocompleteAdditionalFilterParameter = "";
                            result.searchButtonEnabled = true;
                            result.searchWindowTitle = translations["Ressource.Ressourcensuche"];
                            result.searchWindowUrl = "DynamicSearch/Window/Resource";

                            panelbar = {
                                visible: true,
                                type: "is-panelbar-details",
                                model: result.model,
                                url: "ResourceLookup/ResourceHeader",
                                template: "ResourceDetails"
                            };
                            break;
                        case 140:
                            result.type = "is-search-field";
                            result.listWidth = 650;
                            result.autocompleteEnabled = true;
                            result.autocompleteTemplate = "<table cellspacing='0' style='table-layout:fixed; width:650px'><colgroup><col style='width: 100px'/><col style='width: 275px'/><col style='width:275px'/></colgroup><tr><td style='vertical-align:top; word-wrap: break-word;'>${data.AdrNr}</td><td style='vertical-align:top'>${data.Ansprechpartner}</td><td style='vertical-align:top'>${data.Vorname}</td></tr></table>";
                            result.autocompleteUrl = "ContactLookup/Find";
                            result.autocompleteDataTextField = "Pos";
                            result.autocompleteAdditionalFilterParameterName = "";
                            result.autocompleteAdditionalFilterParameter = "";
                            result.searchButtonEnabled = true;
                            result.searchWindowTitle = translations["Ansprechpartner.Ansprechpartnersuche"];
                            result.searchWindowUrl = "DynamicSearch/Window/Contact";

                            panelbar = {
                                visible: true,
                                type: "is-panelbar-details",
                                model: result.model,
                                url: "ContactLookup/ContactPersonHeader",
                                template: "ContactPersonDetails"
                            };
                            break;
                        case 150:
                            result.type = "is-search-field";
                            result.listWidth = 650;
                            result.autocompleteEnabled = false;
                            result.autocompleteTemplate = "";
                            result.autocompleteUrl = "";
                            result.autocompleteDataTextField = "";
                            result.autocompleteAdditionalFilterParameterName = "";
                            result.autocompleteAdditionalFilterParameter = "";
                            result.searchButtonEnabled = true;
                            result.searchWindowTitle = translations["WebSMS.Title.ProcedureSearch"];
                            result.searchWindowUrl = "DynamicSearch/Window/Procedure";

                            panelbar = {
                                visible: true,
                                type: "is-panelbar-details",
                                model: result.model,
                                url: "ProcedureLookup/ProcedureHeader",
                                template: "ProcedureDetails"
                            };
                            break;
                        case 160:
                            result.type = "is-search-field";
                            result.listWidth = 650;
                            result.autocompleteEnabled = true;
                            result.autocompleteTemplate = "<table cellspacing='0' style='table-layout:fixed; width:350px'><colgroup><col style='width: 150px' /><col style='width: 150px' /></colgroup><tr><td style='vertical-align:top; word-wrap: break-word;'>${data.Name}</td><td style='vertical-align:top'>${data.Name2}</td></tr></table>";
                            result.autocompleteUrl = "UserLookup/Find";
                            result.autocompleteDataTextField = "Name";
                            result.autocompleteAdditionalFilterParameterName = "";
                            result.autocompleteAdditionalFilterParameter = "";
                            result.searchButtonEnabled = true;
                            result.searchWindowTitle = translations["Standard.Benutzersuche"];
                            result.searchWindowUrl = "DynamicSearch/Window/User";
                            result.readOnlyTextField = true;

                            panelbar = {
                                visible: true,
                                type: "is-panelbar-details",
                                model: result.model,
                                url: "UserLookup/UserHeader",
                                template: "UserDetails"
                            };
                            break;
                        default:
                            result.type = "textbox";
                            break;
                    }

                    return { item: result, dataSource: dataSource, panelbar: panelbar };
                },
                createDataSource: function (values) {
                    const dataSource = [];
                    for (let i = 0; i < values.length; i++) {
                        if (typeof values[i] === "object") {
                            dataSource.push({ text: values[i].Item2, value: values[i].Item1 });
                        } else {
                            dataSource.push({ text: values[i], value: values[i] });
                        }
                    }
                    return dataSource;
                },
                getItemFromMetadata: function (modelName, guiMetadata) {
                    for (let i = 0; i < guiMetadata.tabs.length; i++) {
                        for (let j = 0; j < guiMetadata.tabs[i].regions.length; j++) {
                            for (let k = 0; k < guiMetadata.tabs[i].regions[j].fields.length; k++) {
                                const parts = guiMetadata.tabs[i].regions[j].fields[k].model.split(".");
                                if (modelName === parts[parts.length - 1]) {
                                    return guiMetadata.tabs[i].regions[j].fields[k];
                                }
                            }
                        }
                    }
                    return null;
                },
                convertTypeForIndividual: function (type) {
                    switch (type) {
                        case 0://textbox
                            return "Textbox";
                        case 1://numeric
                            return "Numeric";
                        case 2://currency
                            return "Currency";
                        case 3://intnumeric
                            return "IntNumeric";
                        case 4://checkbox
                            return "Checkbox";
                        case 5://datetimepicker
                            return "DateTimePicker";
                        case 6://combobox
                            return "Combobox";
                        case 7://multilangcombobox
                            return "MultiLangCombobox";
                        case 8://multilinetext
                            return "MultiLineTextBox";
                        default:
                            return "Textbox";
                    }
                },
            }

            //API
            return {
                createMetadata: function (config, title, metadataObjName, isSingle, translations, toExclude, injectEntityInModel = false, readOnly = false, sideBySide: boolean = false) {
                    const obj = { tabs: [] };
                    const dataSources = {};
                    if (config.categoryMetadata && config.categoryMetadata.length > 0 && !sideBySide) {
                        for (let i = 0; i < config.categoryMetadata.length; i++) {
                            const tab =
                            {
                                title: config.categoryMetadata[i].DisplayName,
                                regions: [
                                    {
                                        title: title,
                                        visible: true,
                                        readOnly :readOnly,
                                        fields: []
                                    }
                                ]
                            };

                            for (let j = 0; j < config.categoryMetadata[i].InputFields.length; j++) {
                                if (!Array.isArray(toExclude) || toExclude.indexOf(config.categoryMetadata[i].InputFields[j].Name) < 0) {
                                    const indiv = tools.getCorrespondingDirective(config.categoryMetadata[i].InputFields[j], isSingle, translations, injectEntityInModel);
                                    tab.regions[0].fields.push(indiv.item);
                                    if (indiv && indiv.dataSource !== null && typeof indiv.dataSource !== "undefined" && indiv.dataSource.name !== null && typeof indiv.dataSource.name !== "undefined") {
                                        dataSources[indiv.dataSource.name] = indiv.dataSource.data;
                                    }
                                    if (indiv && indiv.panelbar !== null && typeof indiv.panelbar !== "undefined") {
                                        tab.regions[0].fields.push(indiv.panelbar);
                                    }
                                }
                            }

                            if (tab.regions[0].fields.length > 0) {
                                obj.tabs.push(tab);
                            }
                        }
                    } else if (sideBySide) {
                        obj.tabs.push(
                            {
                                title: title,                                
                                regions: [
       
                                ]
                            });

                        const fieldMetaData = config.fieldsMetadata;

                        for (let i = 0; i < fieldMetaData.length; i++) {
                            if (!fieldMetaData[i].IsPrimaryKey && fieldMetaData[i].Name != "isguid") {
                                if (!Array.isArray(toExclude) || toExclude.indexOf(fieldMetaData[i].Name.toLowerCase()) < 0) {
                                    const indiv = tools.getCorrespondingDirective(fieldMetaData[i], isSingle, translations, injectEntityInModel);
                                    const region = {
                                        title: indiv.item.name,
                                        visible: true,
                                        renderHeader: false,
                                        readOnly: readOnly,
                                        fields: [
                                            indiv.item
                                        ]
                                    }
                                    if (indiv && indiv.dataSource !== null && typeof indiv.dataSource !== "undefined" && indiv.dataSource.name !== null && typeof indiv.dataSource.name !== "undefined") {
                                        dataSources[indiv.dataSource.name] = indiv.dataSource.data;
                                    }
                                    if (indiv && indiv.panelbar !== null && typeof indiv.panelbar !== "undefined") {
                                        region.fields.push(indiv.panelbar);
                                    }
                                    obj.tabs[0].regions.push(region);
                                }

                            }
                        }
                    } else {
                        obj.tabs.push(
                            {
                                title: title,
                                regions: [
                                    {
                                        title: title,
                                        visible: true,
                                        readOnly : readOnly,
                                        fields: []
                                    }
                                ]
                            });

                        const fieldMetaData = config.fieldsMetadata;

                        for (let i = 0; i < fieldMetaData.length; i++) {
                            if (!fieldMetaData[i].IsPrimaryKey && fieldMetaData[i].Name != "isguid") {
                                if (!Array.isArray(toExclude) || toExclude.indexOf(fieldMetaData[i].Name.toLowerCase()) < 0) {
                                    const indiv = tools.getCorrespondingDirective(fieldMetaData[i], isSingle, translations, injectEntityInModel);
                                    obj.tabs[0].regions[0].fields.push(indiv.item);
                                    if (indiv && indiv.dataSource !== null && typeof indiv.dataSource !== "undefined" && indiv.dataSource.name !== null && typeof indiv.dataSource.name !== "undefined") {
                                        dataSources[indiv.dataSource.name] = indiv.dataSource.data;
                                    }
                                    if (indiv && indiv.panelbar !== null && typeof indiv.panelbar !== "undefined") {
                                        obj.tabs[0].regions[0].fields.push(indiv.panelbar);
                                    }
                                }

                            }
                        }
                    }
                    return { gui: obj, dataSources: dataSources };
                },
                getItemsMixedOnMainTabs: function (metadata) {
                    const result = [];
                    if (metadata && metadata.tabs) {
                        for (let i = 0; i < metadata.tabs.length; i++) {
                            if (metadata.tabs[i].regions) {
                                for (let j = 0; j < metadata.tabs[i].regions.length; j++) {
                                    if (Helper.hasValue(metadata.tabs[i].regions[j].fields)) {
                                        for (let k = 0; k < metadata.tabs[i].regions[j].fields.length; k++) {
                                            const model = metadata.tabs[i].regions[j].fields[k].model;
                                            if (Helper.hasValue(model) && model.indexOf(".IndividualFields.") >= 0) {
                                                const parts = model.split(".");
                                                result.push(parts[parts.length - 1]);
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    return result;
                },
                getFieldsList: function (config, guiMetadata) {
                    const allFields = {};
                    if (config.categoryMetadata) {
                        for (let i = 0; i < config.categoryMetadata.length; i++) {
                            for (let j = 0; j < config.categoryMetadata[i].InputFields.length; j++) {
                                const metaObj = tools.getItemFromMetadata(config.fieldsMetadata[i].Name, guiMetadata);
                                allFields[config.categoryMetadata[i].InputFields[j].Name] = {
                                    name: config.categoryMetadata[i].InputFields[j].Name,
                                    label: config.categoryMetadata[i].InputFields[j].DisplayName,
                                    isKey: config.categoryMetadata[i].InputFields[j].IsPrimaryKey,
                                    isReadOnly: config.categoryMetadata[i].InputFields[j].IsReadOnly,
                                    isRequired: config.categoryMetadata[i].InputFields[j].IsRequired,
                                    defaultValue: config.categoryMetadata[i].InputFields[j].DefaultValue,
                                    type: metaObj === null ? null : metaObj.type
                                };
                            }
                        }
                    } else {
                        for (let i = 0; i < config.fieldsMetadata.length; i++) {
                            const metaObj = tools.getItemFromMetadata(config.fieldsMetadata[i].Name, guiMetadata);
                            allFields[config.fieldsMetadata[i].Name] = {
                                name: config.fieldsMetadata[i].Name,
                                label: config.fieldsMetadata[i].DisplayName,
                                isKey: config.fieldsMetadata[i].IsPrimaryKey,
                                isReadOnly: config.fieldsMetadata[i].IsReadOnly,
                                isRequired: config.fieldsMetadata[i].IsRequired,
                                defaultValue: config.fieldsMetadata[i].DefaultValue,
                                type: metaObj === null ? null : metaObj.type
                            };
                        }
                    }
                    return allFields;
                },
                convertToIndividualItem: function (item, fieldsMetadata, justFromItem = false) {
                    const fieldsArray = [];
                    for (let i = 0; i < fieldsMetadata.length; i++) {
                        if (justFromItem !== true || Helper.hasValue(item[fieldsMetadata[i].Name])) {
                            const tmpField = {
                                Identifier: fieldsMetadata[i].Name,
                                Value: item[fieldsMetadata[i].Name],
                                Type: tools.convertTypeForIndividual(fieldsMetadata[i].Type)
                            };

                            fieldsArray.push(tmpField);
                        }
                    }
                    return fieldsArray;
                },
            };
        }();
    }
}